import {useState} from "react";
import {useHistory} from "react-router-dom";
import {toast} from "react-toastify";
import {Button, Input, LoginBox, LoginContainer, Title} from "../../signatures/loginSignatures/styles";

const LoginAnticipation:React.FC = () => {
  const [password, setPassword] = useState('');
  const history = useHistory();
  const predefinedPassword = 'p6T)}O1@|38w(Vz2045&%';

  const handleLogin = () => {
    if(password === predefinedPassword){
      history.push('/admin/antecipacao-pontual')
    }else {
      toast.error('Senha incorreta!');
    }
  };

  return (
    <LoginContainer>
      <LoginBox>
        <Title>Login Antecipação Pontual</Title>
          <Input
            type='password'
            placeholder='Insira a senha'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            />
        <Button onClick={handleLogin}>Entrar</Button>
      </LoginBox>
    </LoginContainer>
  )
}

export default LoginAnticipation;
